import {Component, OnInit} from '@angular/core';
import {BaseSectionComponent} from "../base-section/base-section.component";
import {CustomSearchInputComponent} from "../../elements/inputs/custom-search-input/custom-search-input.component";
import {NgClass, NgForOf, NgIf} from "@angular/common";
import {SynapiListItemsComponent} from "../../elements/synapi-list-items/synapi-list-items.component";
import {SynapiMapComponent} from "../../elements/synapi-map/synapi-map.component";
import {PageListPagesSection} from "../../../models/Page/Sections/PageListPagesSection";
import {
  EvenementSitPeriods,
  PageEvenementSitSection,
  PageEvenementSitSectionPeriods
} from "../../../models/Page/Sections/PageEvenementSitSection";
import {SynapiPredicate} from "../../../models/Synapi/SynapiPredicate";
import {FindPipe} from "../../../pipes/find.pipe";

@Component({
  selector: 'evenement-sit-section',
  standalone: true,
  imports: [
    BaseSectionComponent,
    CustomSearchInputComponent,
    NgIf,
    SynapiListItemsComponent,
    SynapiMapComponent,
    NgClass,
    NgForOf,
    FindPipe
  ],
  templateUrl: './evenement-sit-section.component.html',
  styleUrl: './evenement-sit-section.component.scss'
})
export class EvenementSitSectionComponent extends BaseSectionComponent<PageEvenementSitSection> implements OnInit{
  periodsActiveCount = 0;
  override ngOnInit() {
    super.ngOnInit();
    for(let period of this.sectionRendered.periods){
      period.active = true;
      if (period.cyclic_period) {
        if(!period.from && !period.to){
          switch (period.cyclic_period) {
            case EvenementSitPeriods.MONTH:
              const currentDate = new Date();
              const firstDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
              const lastDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
              period.from = this.formatDate(firstDayOfMonth); // First day of current month formatted as Y-m-d
              period.to = this.formatDate(lastDayOfMonth); // Last day of current month formatted as Y-m-d
              break;
            case EvenementSitPeriods.WEEKEND:
              const weekendDate = this.getWeekendDate();
              period.from = this.formatDate(weekendDate[0]); // Saturday or current day if in weekend formatted as Y-m-d
              period.to = this.formatDate(weekendDate[1]); // Weekend end date formatted as Y-m-d
              break;
            case EvenementSitPeriods.TODAY:
              period.from = this.formatDate(new Date()); // Current date formatted as Y-m-d
              period.to = this.formatDate(new Date()); // Current date formatted as Y-m-d
              break;
            case EvenementSitPeriods.NEXT:
              const nextOpenDay = this.getNextOpenDay();
              period.from = this.formatDate(nextOpenDay);
              const nextYear = new Date(nextOpenDay.setFullYear(nextOpenDay.getFullYear() + 1));
              period.to = this.formatDate(nextYear);
              break;
          }
        }
      }
    }
  }

  // Function to format date as Y-m-d
  formatDate(date: Date) {
    const year = date.getFullYear();
    let month = date.getMonth() + 1;
    const monthStr = month < 10 ? '0' + month : month;
    let day = date.getDate();
    const dayStr = day < 10 ? '0' + day : day;
    return year + '-' + monthStr + '-' + dayStr;
  }

// Function to get weekend dates
  getWeekendDate() {
    const today = new Date();
    const dayOfWeek = today.getDay();
    let saturday, sunday;

    if (dayOfWeek === 6) {
      // Today is Saturday, so the weekend has already started
      saturday = new Date(today);
      sunday = new Date(today);
      sunday.setDate(today.getDate() + 1); // Next day (Sunday)
    } else if (dayOfWeek === 0) {
      // Today is Sunday, so the weekend is today and tomorrow
      saturday = new Date(today);
      saturday.setDate(today.getDate() - 1); // Previous day (Saturday)
      sunday = new Date(today);
    } else {
      // Otherwise, find the next Saturday and Sunday
      saturday = new Date(today);
      saturday.setDate(today.getDate() + (6 - dayOfWeek) + 1); // Next Saturday
      sunday = new Date(today);
      sunday.setDate(today.getDate() + (7 - dayOfWeek) + 1); // Next Sunday
    }

    return [saturday, sunday]; // Returning Saturday and Sunday as an array
  }

// Function to get next date
  getNextOpenDay() {
    const today = new Date();
    let nextDay = new Date(today);

    // Increment the day until it's not Saturday or Sunday
    do {
      nextDay.setDate(nextDay.getDate() + 1); // Next day
    } while (nextDay.getDay() === 0 || nextDay.getDay() === 6); // 0 is Sunday, 6 is Saturday

    return nextDay;
  }

  onPeriodTotal(period:PageEvenementSitSectionPeriods,$event:number){
    period.active = $event>0;
    this.periodsActiveCount = this.sectionRendered.periods.filter((p)=>p.active).length
    this.sectionRendered.active = this.periodsActiveCount>0;
  }
}
